import React from 'react';
import { useExperiments, useTranslation } from '@wix/yoshi-flow-editor';
import {
  SectionNotification,
  SectionNotificationType,
} from 'wix-ui-tpa/cssVars';
import { classes } from './BuyPlanParticipantsNotification.st.css';
import { ServiceData, SlotService } from '../../../../utils/state/types';
import { mapToArray } from '../../../../utils';
import { PaymentType } from '../../../../types/types';
import { getIsMultiParticipantFlowActive } from '../../../../utils/multiParticipantFlow';
import { ExperimentsConsts } from '../../../../consts/experiments';

export const BUY_PLAN_PARTICIPANTS_MESSAGE_KEY =
  'bookings.form.collectParticipant.buyPlan.message';

interface BuyPlanParticipantsNotificationProps {
  serviceData: ServiceData;
}

/**
 * "Buy a plan" is a detour, not a booking: the visitor buys the plan and comes back to this
 * form to book. With several participants that means the other participants' bookings and
 * payments happen only after the return, so say so under the CTA.
 */
export const BuyPlanParticipantsNotification: React.FC<
  BuyPlanParticipantsNotificationProps
> = ({ serviceData }) => {
  const { t } = useTranslation();
  const { experiments } = useExperiments();
  const isMultiParticipantFlowActive = getIsMultiParticipantFlowActive(
    serviceData,
    experiments.enabled(ExperimentsConsts.CollectParticipantForm),
  );
  const slotService = mapToArray<SlotService>(serviceData.slotServices)[0];
  const selectedType = slotService?.selectedPaymentOption?.type;
  const isBuyingPlan =
    selectedType === PaymentType.BUY_PLAN ||
    selectedType === PaymentType.BUY_PLAN_AND_BOOK;

  if (
    !isMultiParticipantFlowActive ||
    !isBuyingPlan ||
    (slotService.participants?.length ?? 0) < 2
  ) {
    return null;
  }

  return (
    <SectionNotification
      type={SectionNotificationType.default}
      className={classes.root}
      data-hook="buy-plan-participants-message"
    >
      <SectionNotification.Text>
        {t(BUY_PLAN_PARTICIPANTS_MESSAGE_KEY)}
      </SectionNotification.Text>
    </SectionNotification>
  );
};
